/**
 * One sentence, centred in whatever space is left.
 *
 * What a full-screen route says when it has no screen to show: a design that is
 * still opening, a campaign that is not there, a message with nothing in it yet.
 * Compose and the preview tab both sit outside the shell, so neither has an
 * empty state to borrow — and both had their own copy of this.
 */
export function ScreenNote({ children }: { readonly children: string }) {
  return (
    <p className="flex flex-1 items-center justify-center px-6 text-center text-[13px] text-t2">
      {children}
    </p>
  )
}
